const GET_BY_COUNTRY = "GET_BY_COUNTRY";
const GET_DROP_DOWN_LIST = "GET_DROP_DOWN_LIST";
const GET_WORLD_DATA = "GET_WORLD_DATA";
const ERROR_MESSAGE = "ERROR_MESSAGE";
const DAILY_RECORDS = "DAILY_RECORDS";
const USER_LOCATION = "USER_LOCATION";

const Types = {
  GET_BY_COUNTRY,
  GET_DROP_DOWN_LIST,
  GET_WORLD_DATA,
  ERROR_MESSAGE,
  DAILY_RECORDS,
  USER_LOCATION
}

export default Types;